<!-- h -->
<template>
  <common-dialog ref="dialog" :title="title" width="1100px" :in-dialog="inDialog" @opened="onOpen">
    <div class="index-tree-box">
      <type-tree ref="tree" auto-h show-action @on-select="treeSelect" @title-click="titleClick" v-if="!this.IdChain"/>
      <div :class="{'right-box' : !this.IdChain, 'themain-box': this.IdChain > 0}">
        <list ref="list" common :show-checkbox="multiple" :multiple="multiple" :showTrendTable="false" :modelType="modelType" >
          <template #column>
            <slot name="column" />
            <template v-if="selectable&&!multiple">
              <el-table-column label="操作" align="center" width="60" fixed="right">
                <template slot-scope="{row}">
                  <el-button :disabled="row.DistrictId==NoId" @click="onSelect(row)" type="text">选择</el-button>
                </template>
              </el-table-column>
            </template>
          </template>
        </list>
      </div>
    </div>
    <template slot="footer">
      <slot name="footer">
        <el-button type="primary" @click="selectMultiple" v-if="selectable&&multiple">选择</el-button>
      </slot>
    </template>
  </common-dialog>
</template>
<script>
import commonDialog from "@/components/common/dialog";
import list from "./list";
import listDialogMixins from "@/mixins/listDialog";
import typeTree from "./type/tree";

export default {
  components: { commonDialog, list, typeTree },
  mixins: [listDialogMixins],
  props: {
    title: {
      type: String,
      default: "人员列表",
    },
    modelType: {
      type: String,
      default: "personnelresultrecord",
    },
    selectable: {
      type: Boolean,
      default: true,
    },
    IdChain: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      params: {},
      NoId: 0,
    };
  },
  created(){
    
  },
  methods: {
    onOpen(){
      console.log('onOpen', this.IdChain);
      if (this.IdChain) {
        this.getData(this.params);
      }
      
    },
    getTree(){
        this.$refs.tree.getData();
    },
    getData(params = {}) {
      // console.log('我执行到这');
      // this.NoId = params.NoId;

      console.log('onOpen2', this.IdChain);

      this.params = { ...params };

      if (this.IdChain) {
        console.log('onOpen3', this.params);
        this.$refs.list.getData( {...this.params, IdChain: this.IdChain});
      }
      else {
        this.$refs.tree.getData();
        this.$refs.list.getData(this.params);
      }
    },
    treeSelect(data) {
      this.$refs.list.getData({ ...this.params, IdChain: data.IdChain });
    },
    titleClick() {
      this.$refs.list.getData({ ...this.params, IdChain: null });
    },
  },
};
</script>
<style>
    .themain-box {
    width      : calc(100%);
    margin-left: 0px;
    padding    : 10px;
    border     : 1px solid #e4e7ed;
    overflow   : auto;
  }
</style>